const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export const resolveAssetUrl = (path?: string | null): string | undefined => {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BASE.replace(/\/$/, '')}/${path.replace(/^\//, '').replace("api/", "")}`;
};